import LogoVipFr from '../src/LogoVipFr';
export default LogoVipFr;
